import { render, staticRenderFns } from "./CreditorAgeing.vue?vue&type=template&id=1d6ab990&scoped=true&"
import script from "./CreditorAgeing.vue?vue&type=script&lang=js&"
export * from "./CreditorAgeing.vue?vue&type=script&lang=js&"
import style0 from "./CreditorAgeing.vue?vue&type=style&index=0&id=1d6ab990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ab990",
  null
  
)

export default component.exports